import { render, staticRenderFns } from "./StaffChangePassword.vue?vue&type=template&id=366e691e&"
import script from "./StaffChangePassword.vue?vue&type=script&lang=js&"
export * from "./StaffChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./StaffChangePassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports